"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  MuiPickersCalendar: {
    root: {
      minHeight: 240
    }
  },
  MuiPickersDay: {
    root: {
      borderRadius: 0
    }
  }
};
exports.default = _default;